import { Settings } from '$/io.ox/core/settings'

export const defaults = {
  logo: 'themes/io.ox.survey/static/ox_logo_blue.svg',
  minUserCreationDate: '',
  delayFromFirstLogin: 0,
  survey: {
    en_US: {
      generation: 1,
      intro: '<span class=\'salutation\'>Dear Customer,</span><br/>We\'re always looking to improve our webmail service by asking for feedback from our customers. We\'d appreciate it if you\'d take a few moments to complete this survey.',
      privacy: '<span>Your privacy is important to us:</span><br/>Your participation is fully anonymous. We do not collect any personal data from you beyond the questions asked in the survey',
      link: 'https://openxchange.co1.qualtrics.com/jfe/form/SV_6ul0Zgc77Ee8eQl'
    }
  }
}

export const settings = new Settings('io.ox.survey', () => defaults)
